/*
  Pure Grounds: sticky buy bar on phones. Shows while the product form's submit button is out of view and
  clicks that button, so Dawn's own product-form handler (and the gift bag listener) run unchanged.
*/
if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.section;
        this.target = document.getElementById('ProductSubmitButton-' + this.sectionId);
        this.button = this.querySelector('.sticky-atc__button');
        this.priceEl = this.querySelector('.sticky-atc__price');
        if (!this.target || !this.button || !('IntersectionObserver' in window)) return;

        this.button.addEventListener('click', () => {
          if (this.target.disabled) return;
          this.target.click();
        });

        this.observer = new IntersectionObserver((entries) => this.toggle(!entries[0].isIntersecting), { threshold: 0 });
        this.observer.observe(this.target);
        this.sync();

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, () => setTimeout(() => this.sync(), 50));
        }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.unsubscribe) this.unsubscribe();
        document.body.classList.remove('sticky-atc-visible');
      }

      /** Mirror the form's price, label and disabled state (sold out, unavailable). */
      sync() {
        const target = document.getElementById('ProductSubmitButton-' + this.sectionId) || this.target;
        this.target = target;
        const label = target.querySelector('span');
        const mine = this.button.querySelector('span');
        if (label && mine) mine.textContent = label.textContent.trim();
        this.button.disabled = target.disabled;

        const container = document.getElementById('price-' + this.sectionId);
        if (container && this.priceEl) {
          const onSale = !!container.querySelector('.price--on-sale');
          const el = container.querySelector(onSale ? '.price__sale .price-item--sale' : '.price__regular .price-item--regular');
          if (el) this.priceEl.textContent = el.textContent.trim();
        }
      }

      toggle(show) {
        this.hidden = !show;
        document.body.classList.toggle('sticky-atc-visible', show);
      }
    }
  );
}
